export enum AdminBrandBannerListItemAction {
  Preview = 'PREVIEW',
  Edit = 'EDIT',
  Remove = 'REMOVE',
}
